// extracted by mini-css-extract-plugin
module.exports = {"text":"TotalPayableStrip_text__3HkvF","amount":"TotalPayableStrip_amount__2gGaT"};